import {
    Component,
    Inject,
    OnInit,
    Optional,
    QueryList,
    ViewChildren,
} from '@angular/core';
import { CreateNewPatientModalService } from './create-new-patient-modal.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import {
    MatDialogRef,
    MAT_DIALOG_DATA,
    MatDialog,
} from '@angular/material/dialog';
import * as moment from 'moment';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { DisallowSpacesDirective } from '../../../../directive/disallow-spaces.directive';
import { MatInputModule } from '@angular/material/input';
import {
    MatAutocompleteModule,
    MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import {
    callSourceArray,
    carrierTypeArray,
    checkExternalIdExistsOrNot,
    checkExternalIdExistsPayload,
    createNewPatient,
    DateOfBirthObject,
    digitalConsentArray,
    genderArray,
    getMaxDaysInMonth,
    isValidCalendarDate,
    leadSourceArray,
    medicarePrescriptionPaymentPlanArray,
    months,
    patientInformationObject,
    preferredApptReminderMethodArray,
    relationshipArray,
    salutationArray,
} from './create-new-patient-interfaces';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { InboxService } from '../../inbox/inbox.service';
import { PatientDetailMergeModalComponent } from '../patient-details-merge-modal/patient-detail-merge-modal.component';
import { CustomPatientLabelPipe } from '../../pipes/patient-label.pipe';
import { Subscription } from 'rxjs';
import { ApisService } from 'src/app/services/apis.service';
import { getCodeValueByCategoryIdResult } from '../patients-interface';
import { HttpErrorResponse } from '@angular/common/http';
import { reservedCodeCategories } from 'admin-ui-v2-config';
import { LocalServiceService } from 'src/app/services/local-service.service';
import { groupFieldsByNearestName } from '../patient-field-grouping.util';

@Component({
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ToastrModule,
        MatSelectModule,
        DisallowSpacesDirective,
        MatInputModule,
        MatAutocompleteModule,
        NgSelectModule,
        CustomPatientLabelPipe,
    ],
    providers: [CustomPatientLabelPipe],
    selector: 'app-create-new-patient-modal',
    templateUrl: './create-new-patient-modal.component.html',
    styleUrls: ['./create-new-patient-modal.component.css'],
})
export class CreateNewPatientModalComponent implements OnInit {
    @ViewChildren(NgSelectComponent)
    ngSelectComponents!: QueryList<NgSelectComponent>;
    @ViewChildren(MatAutocompleteTrigger)
    autocompleteTriggers!: QueryList<MatAutocompleteTrigger>;
    genderArr: { value: string; label: string }[] = [
        { value: 'MALE', label: 'Male' },
        { value: 'FEMALE', label: 'Female' },
    ];
    __temporaryPassword: number | null = null;
    isValid: boolean = true;
    emailRegex: RegExp = /^[\S]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    nameRegex: RegExp = /^[A-Za-z0-9 ]+$/;
    phoneRegex: RegExp = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
    deformatPhoneRegex: RegExp = /[^A-Za-z0-9]+/g;
    tempPhone: string = '';
    email: string = '';
    loader: boolean = false;
    checkExternalIdExistsOrNot: checkExternalIdExistsOrNot = {
        data: {
            isSameOrgEntity: false,
            isExternalIdAlreadyPresent: false,
            newOrgEntityId: '',
            isNew: false,
        },
        isActionSuccess: false,
    };
    patientInformationObject: patientInformationObject = {
        patientInfo: {
            isIndividual: true,
            type: 'PATIENT',
            displayName: '',
            firstName: '',
            middleName: '',
            lastName: '',
            dateOfBirth: '',
            gender: '',
            externalId: '',
            homePhone: '',
            cellPhone: '',
            email: '',
            callSource: '',
            leadSource: '',
            healthPlan: '',
            memberId: '',
            language: '',
            address: {
                addressLine1: '',
                addressLine2: '',
                city: '',
                postalCode: '',
                stateOrProvinceCode: null,
            },
        },
    };
    dateOfBirthObject: DateOfBirthObject = {
        dateOfBirth: '',
        dobMonth: null,
        dobYear: '',
        dobDay: null,
    };
    getCodeValueByCategoryIdAddressTimezone: Subscription = new Subscription();
    addressTimezone: any[] = [];
    patientCreationModelMap: any[] = [];
    leadSourceArray: any[] = [];
    callSourceArray = callSourceArray;
    salutationArray = salutationArray;
    genderArray = genderArray;
    relationshipArray = relationshipArray;
    healthPlanArray: any[] = [];
    languageArray: any[] = [];
    timezoneArray: any[] = [];
    enrollmentStatusArray: any[] = [];
    leadStatusArray: any[] = [];
    preferredApptReminderMethodArray = preferredApptReminderMethodArray;
    carrierTypeArray = carrierTypeArray;
    medicarePrescriptionPaymentPlanArray = medicarePrescriptionPaymentPlanArray;
    digitalConsentArray = digitalConsentArray;
    formData: any = {};
    categoryIds: any[] = [];
    patientDetailsAddObj: any;
    groupedAdditionalFields: any[] = [];
    private initialFormSnapshot = '';
    private initialEditValues: any = null;
    private isStoredDobNotPrefilled = false;
    editGeneralDetailsVisibleFields = new Set<string>();
    editGeneralDetailsRequiredFields = new Set<string>();
    editGeneralDetailsEditableFields = new Set<string>();
    private editGeneralDetailsConfigPresent = false;
    constructor(
        public createNewPatientService: CreateNewPatientModalService,
        private toastr: ToastrService,
        public dialog: MatDialog,
        private localService: LocalServiceService,
        private inboxService: InboxService,
        private customPatientLabelPipe: CustomPatientLabelPipe,
        public dialogRef: MatDialogRef<CreateNewPatientModalService>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            showBackToSearch: boolean;
            patientDetails: any;
            editPatient: boolean;
            stateList: any[];
            orgEntityId?: string;
            patientAdditionalFields: any;
            additionalDetailsEmittedValue: any;
        },
        public api: ApisService,
    ) {}
    day: string = '';
    days: string[] = [];
    months = months;
    isPatientCreationModelEnabled = false;
    setDays() {
        const monthId = String(this.dateOfBirthObject.dobMonth ?? '');
        if (!this.months.some((m) => m.id === monthId)) {
            return;
        }
        const maxDays = getMaxDaysInMonth(
            monthId,
            this.dateOfBirthObject.dobYear,
        );
        this.days = [];
        for (let i = 1; i <= maxDays; i++) {
            this.days.push(String(i).padStart(2, '0'));
        }
    }
    onDobYearChange(year: string) {
        this.dateOfBirthObject.dobYear = year;
        this.setDays();
        const day = this.dateOfBirthObject.dobDay;
        if (day && Number(day) > this.days.length) {
            this.dateOfBirthObject.dobDay = null;
            this.toastr.warning(
                'Selected day is not valid for this month and year. Please select the day again.',
            );
        }
    }
    // Returns the reason the entered birth date cannot be saved, or null when it is fine/incomplete.
    getDobError(): string | null {
        const { dobMonth, dobDay, dobYear } = this.dateOfBirthObject;
        if (!dobMonth || !dobDay || !dobYear) {
            return null;
        }
        if (!/^\d{4}$/.test(String(dobYear))) {
            return 'Please enter a valid 4-digit birth year';
        }
        if (!isValidCalendarDate(dobMonth, dobDay, dobYear)) {
            return 'Invalid birth date';
        }
        if (Number(dobYear) < 1900) {
            return 'Birth year should be greater than or equal to 1900.';
        }
        if (
            this.checkIfDateOfBirthIsGreaterThanCurrentDate(
                new Date(Number(dobYear), Number(dobMonth) - 1, Number(dobDay)),
            )
        ) {
            return "Birth date can't be greater than or equal to the current date";
        }
        return null;
    }
    checkNumber(event: any) {
        /**check the value of the keyPress to make sure it's a num. which from 48-57 are 0-9 */
        if ((event.which !== 8 && event.which < 48) || event.which > 57) {
            event.preventDefault();
        }
    }

    checkIfDateOfBirthIsGreaterThanCurrentDate(enteredDateOfBirth: any) {
        enteredDateOfBirth = new Date(enteredDateOfBirth);
        enteredDateOfBirth.setHours(0, 0, 0, 0);
        var currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        return enteredDateOfBirth >= currentDate;
    }
    closeModal() {
        this.dialogRef.close({ goBackToSearch: false });
    }
    // Dropdown panels are appended to body, so they do not follow the scrolling modal body.
    closeOpenDropdowns() {
        this.ngSelectComponents?.forEach((ngSelect) => {
            if (ngSelect.isOpen) {
                ngSelect.close();
            }
        });
        this.autocompleteTriggers?.forEach((trigger) => {
            if (trigger.panelOpen) {
                trigger.closePanel();
            }
        });
    }
    monthName(value1: string) {
        if (value1) {
            if (this.months?.find((month) => month.id === value1)) {
                return this.months?.find((month) => month.id === value1)
                    ?.displayName;
            }
        }
        return null;
    }
    removeAllSpace() {
        setTimeout(() => {
            this.patientInformationObject.patientInfo.externalId =
                this.patientInformationObject.patientInfo.externalId.replaceAll(
                    /\s/g,
                    '',
                );
        }, 0);
    }

    private getPatientIdLabel(): string {
        return (
            this.customPatientLabelPipe.transform('Patient ID') || 'Patient ID'
        );
    }

    private getAlreadyExistsPatientIdMessage(): string {
        const patientIdLabel = this.getPatientIdLabel();
        return `${patientIdLabel} already exists, please enter another one.`;
    }

    isFieldRequired(config: any): boolean {
        if (!config || typeof config !== 'object') {
            return false;
        }

        const requiredKeys = ['required', 'isRequired'];

        for (const key of requiredKeys) {
            if (!Object.prototype.hasOwnProperty.call(config, key)) {
                continue;
            }

            const value = config[key];
            if (
                value === true ||
                value === 1 ||
                value === 'true' ||
                value === '1'
            ) {
                return true;
            }
        }

        return false;
    }

    isPatientUsernameField(col: any): boolean {
        const columnValue = (col?.columnValue || '').toString().toUpperCase();

        return columnValue === 'PATIENT_USERNAME';
    }

    getPatientUsernameFieldValue(col: any): string {
        const dataProperty = col?.dataProperty;
        if (!dataProperty) {
            return '';
        }

        const candidateValues = [
            this.data?.additionalDetailsEmittedValue?.[dataProperty],
            this.data?.patientDetails?.[dataProperty],
            this.formData?.[dataProperty],
        ];

        for (const value of candidateValues) {
            if (value === null || value === undefined) {
                continue;
            }

            const normalizedValue = value.toString().trim();
            if (normalizedValue) {
                return normalizedValue;
            }
        }

        return '';
    }

    private isValidPhoneUsername(value: string): boolean {
        if (!value) {
            return false;
        }

        const normalizedValue = value.toString().trim();
        if (!/^\d+$/.test(normalizedValue)) {
            return false;
        }

        const normalizedDigits =
            normalizedValue.length === 11 && normalizedValue.startsWith('1')
                ? normalizedValue.slice(1)
                : normalizedValue;

        return normalizedDigits.length === 10;
    }

    isPatientUsernameValidTenDigitNumber(col: any): boolean {
        if (!this.data?.editPatient || !this.isPatientUsernameField(col)) {
            return false;
        }

        const currentValue = this.getPatientUsernameFieldValue(col);
        return this.isValidPhoneUsername(currentValue);
    }

    validatePatientInfoExtendedInfo() {
        this.isValid = true;
        const isDOBRequired = this.isRequired('dateOfBirth');
        let isLeapYear =
            parseInt(this.dateOfBirthObject.dobYear) % 100 === 0
                ? parseInt(this.dateOfBirthObject.dobYear) % 400 === 0
                : parseInt(this.dateOfBirthObject.dobYear) % 4 === 0;
        if (
            this.patientCreationModelMap &&
            this.isPatientCreationModelEnabled &&
            this.patientCreationModelMap.length > 0
        ) {
            for (const field of this.patientCreationModelMap) {
                const canonicalFieldLabel = this.getCanonicalGeneralDetailsKey(
                    field?.label,
                );
                if (!this.isEditable(field.label, 'create')) {
                    continue;
                }

                if (this.isFieldRequired(field)) {

                    let value: any;
                    if (canonicalFieldLabel === 'timezone') {
                        value =
                            this.patientInformationObject.patientInfo.address
                                ?.timezone;
                    } else if (canonicalFieldLabel === 'preferredLanguage') {
                        value =
                            this.patientInformationObject.patientInfo.language;
                    } else if (canonicalFieldLabel === 'patientId') {
                        value =
                            this.patientInformationObject.patientInfo.externalId;
                    } else if (canonicalFieldLabel === 'dateOfBirth') {
                        value =
                             this.dateOfBirthObject?.dobMonth &&
                                    this.dateOfBirthObject?.dobDay &&
                                    this.dateOfBirthObject?.dobYear
                                        ? `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`
                                        : null
                    }  else if (canonicalFieldLabel === 'address') {
                        const address = this.patientInformationObject.patientInfo.address;
                        const requiredAddressFields = [
                            'addressLine1',
                            'city',
                            'postalCode',
                            'stateOrProvinceCode'
                        ];
                        const isAddressInvalid =
                            !address ||
                            requiredAddressFields.some(
                                key =>
                                    !address[key] ||
                                    (typeof address[key] === 'string' &&
                                        !address[key].trim())
                            );
                        if (isAddressInvalid) {
                            this.toastr.warning(`Street, city, state and zip code are mandatory fields for address`);
                            this.isValid = false;
                        }
                    } else {
                        value =
                            this.patientInformationObject.patientInfo[
                                field.label as keyof typeof this.patientInformationObject.patientInfo
                            ];
                    }
                    if ((canonicalFieldLabel !== 'address' && canonicalFieldLabel !== 'dateOfBirth') &&
                        !value ||
                        (typeof value === 'string' && !value.trim())
                    ) {
                        this.toastr.warning(
                            `Please enter ${field.displayName || field.label}`,
                        );
                        this.isValid = false;
                    }
                }
            }
        }
        if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.externalId.length > 100
        ) {
            this.toastr.warning(
                `${this.getPatientIdLabel()} should be less than 100 characters`,
            );
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.firstName.length > 60
        ) {
            this.toastr.warning(`First name should be less than 60 characters`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.lastName.length > 60
        ) {
            this.toastr.warning(`Last name should be less than 60 characters`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.homePhone &&
            (this.patientInformationObject.patientInfo.homePhone.length !==
                15 ||
                !this.phoneRegex.test(
                    this.patientInformationObject.patientInfo.homePhone,
                ))
        ) {
            this.toastr.warning(`Please enter valid Home Phone Number`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.cellPhone &&
            (this.patientInformationObject.patientInfo.cellPhone.length !==
                15 ||
                !this.phoneRegex.test(
                    this.patientInformationObject.patientInfo.cellPhone,
                ))
        ) {
            this.toastr.warning(`Please enter valid Cell Phone Number`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.email &&
            !this.emailRegex.test(
                this.patientInformationObject.patientInfo.email,
            )
        ) {
            // if (!this.emailRegex.test(this.patientInformationObject.patientInfo.emailAddresses[0].email)) {
            this.toastr.warning(`Enter a valid Confidential Email`);
            this.isValid = false;
            // }
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.email.length > 100
        ) {
            this.toastr.warning(
                `Email address should be less than 100 characters`,
            );
            this.isValid = false;
        }  else if (this.isPatientCreationModelEnabled === true && this.dateOfBirthObject) {
            const { dobMonth, dobDay, dobYear } = this.dateOfBirthObject;
            const isAnyDobFilled = !!(dobMonth || dobDay || dobYear);
            const isAllDobFilled = !!(dobMonth && dobDay && dobYear);
            if (isDOBRequired && !isAllDobFilled) {
                if (!dobMonth) {
                    this.toastr.warning('Please enter your DOB Month');
                } else if (!dobDay) {
                    this.toastr.warning('Please enter your DOB Day');
                } else if (!dobYear) {
                    this.toastr.warning('Please enter your DOB Year');
                }
                this.isValid = false;
            }
            if (!isDOBRequired && isAnyDobFilled && !isAllDobFilled) {
                if (!dobMonth) {
                    this.toastr.warning('Please enter your DOB Month');
                } else if (!dobDay) {
                    this.toastr.warning('Please enter your DOB Day');
                } else if (!dobYear) {
                    this.toastr.warning('Please enter your DOB Year');
                }
                this.isValid = false;
            }
    } else if (
            this.isValid &&
            this.dateOfBirthObject.dobMonth &&
            this.dateOfBirthObject.dobDay &&
            this.dateOfBirthObject.dobYear
        ) {
            if (
                this.dateOfBirthObject.dobMonth < 10 &&
                this.dateOfBirthObject.dobDay >= 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
            } else if (
                this.dateOfBirthObject.dobDay < 10 &&
                this.dateOfBirthObject.dobMonth >= 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
            } else if (
                this.dateOfBirthObject.dobDay < 10 &&
                this.dateOfBirthObject.dobMonth < 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
            } else {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
            }
            var date = moment(
                this.patientInformationObject.patientInfo.dateOfBirth,
            );
            if (date.isValid()) {
                var currentDateTime = new Date();
                var expirationDateTime = new Date(
                    this.patientInformationObject.patientInfo.dateOfBirth,
                );
                if (expirationDateTime.getTime() > new Date().getTime()) {
                    this.toastr.warning(
                        "Birth date can't be greater than or equal to the current date",
                    );
                    this.isValid = false;
                } else if (+this.dateOfBirthObject.dobYear < 1900) {
                    this.toastr.warning(
                        'Birth year should be greater than or equal to 1900.',
                    );
                    this.isValid = false;
                } else if (
                    expirationDateTime.getMonth() ===
                        currentDateTime.getMonth() &&
                    expirationDateTime.getFullYear() ===
                        currentDateTime.getFullYear() &&
                    expirationDateTime.getDate() === currentDateTime.getDate()
                ) {
                    this.toastr.warning(
                        "Birth date can't be greater than or equal to the current date",
                    );
                    this.isValid = false;
                } else if (
                    this.dateOfBirthObject.dobMonth.toString() == '02' &&
                    this.dateOfBirthObject.dobDay > 28 &&
                    !isLeapYear
                ) {
                    this.toastr.warning('Invalid birth date');
                    this.isValid = false;
                } else {
                    this.isValid = true;
                }
            } else {
                this.toastr.warning('Date of birth is invalid');
                this.isValid = false;
            }
        }
        if (this.isValid) {
            const dobError = this.getDobError();
            if (dobError) {
                this.toastr.warning(dobError);
                this.isValid = false;
            }
        }
         if (
            this.patientInformationObject.patientInfo?.address?.postalCode &&
            this.patientInformationObject.patientInfo.address.postalCode.trim() !== '' &&
            this.patientInformationObject.patientInfo.address.postalCode.trim().length !== 5 &&
            this.patientInformationObject.patientInfo.address.postalCode.trim().length !== 9
        ) {
             this.toastr.warning(`Zip Code must be 5 or 9 digits`);
            this.isValid = false;
        }

        return this.isValid;
    }
    formatNumber() {
        this.formatPhoneNumberAndValidate();
    }
    formatPhoneNumberAndValidate() {
        this.patientInformationObject.patientInfo.homePhone =
            this.cleanPhoneNumber(
                this.patientInformationObject.patientInfo.homePhone,
            );
        this.patientInformationObject.patientInfo.cellPhone =
            this.cleanPhoneNumber(
                this.patientInformationObject.patientInfo.cellPhone,
            );
          if (
        this.data &&
        this.data.patientAdditionalFields &&
        Array.isArray(this.data.patientAdditionalFields.columns)
    ) {
        for (const col of this.data.patientAdditionalFields.columns) {
            const type = (col.type || '').toString().toUpperCase();
            const prop = col.dataProperty;
            if (
                prop &&
                (type === 'NUMERIC(PHONE)')
            ) {
                const raw = this.formData[prop];
                if (raw) {
                    this.formData[prop] = this.cleanPhoneNumber(raw);
                } else {
                    this.formData[prop] = '';
                }
            }
        }
    }
    }
    filterPhoneNumber = (phoneNumber: string) => {
        if (!phoneNumber) {
            return '';
        }
        var value = phoneNumber.toString().trim().replace(/^\+/, '');
        if (value.match(/[^0-9]/)) {
            return phoneNumber;
        }
        var country,
            city,
            number = value;
        if (number) {
            if (number.length > 6) {
                number =
                    number.slice(0, 3) +
                    '-' +
                    number.slice(3, 6) +
                    '-' +
                    number.slice(6, 10);
            } else if (number.length > 3) {
                number = number.slice(0, 3) + '-' + number.slice(3, 6);
            }
            return ('+1 ' + number).trim();
        } else {
            return '+1 ' + number;
        }
    };

    cleanPhoneNumber(phone: string): string {
        if (!phone) return '';

        phone = phone.replace(/-/g, '');

        if (phone.includes('+')) {
            phone = phone.slice(3);
        }

        return this.filterPhoneNumber(phone);
    }
    formatPhoneNumber(phone: string): string {
        if (!phone) return '';
        let digits = phone.replace(/\D/g, '');
        if (digits.length === 11 && digits.startsWith('1')) {
            digits = digits.slice(1);
        }
        digits = digits.slice(0, 10);
        return digits;
    }
    createPatientInformation() {
        if (this.loader) {
            return;
        }
        if (this.validatePatientInfoExtendedInfo()) {
            this.loader = true;
            this.patientDetailsAdd()
            var checkObject: checkExternalIdExistsPayload = {
                externalId: '',
            };
            if (!this.__temporaryPassword) {
                this.__temporaryPassword = Math.floor(
                    100000 + Math.random() * 900000,
                );
            }
            checkObject.externalId =
                this.patientInformationObject.patientInfo.externalId;

            if (this.isPatientCreationModelEnabled == true && checkObject.externalId && checkObject.externalId.length > 0) {
                this.createNewPatientService
                    .checkExternalIdAlreadyExistsOrNot(checkObject)
                    .then((result: any) => {
                        if (result && result.data) {
                            const checkResult: checkExternalIdExistsOrNot = {
                                data: result.data,
                                isActionSuccess: result.isActionSuccess,
                            };
                            if (
                                checkResult &&
                                checkResult.data &&
                                checkResult.data.isExternalIdAlreadyPresent
                            ) {
                                this.toastr.warning(
                                    this.getAlreadyExistsPatientIdMessage(),
                                );
                                this.loader = false;
                            } else if (
                                checkResult &&
                                checkResult.data &&
                                !checkResult.data.isExternalIdAlreadyPresent
                            ) {
                                this.createPatient();
                            } else {
                                this.loader = false;
                            }
                        } else {
                            this.loader = false;
                        }
                    })
                    .catch((error: any) => {
                        console.log(error);
                        this.toastr.error(
                            error.error?.message ||
                                error?.error?.Error ||
                                'Unknown error occurred. Please contact administrator.',
                        );
                        this.loader = false;
                    });
            }else{
                this.createPatient();
            }
        }
    }

    patientDetailsAdd(){
         this.patientInformationObject.patientInfo.cellPhone =
                                    this.cleanPhoneNumber(
                                        this.patientInformationObject
                                            .patientInfo.cellPhone,
                                    );
                                this.patientInformationObject.patientInfo.homePhone =
                                    this.cleanPhoneNumber(
                                        this.patientInformationObject
                                            .patientInfo.homePhone,
                                    );

        const patientCreationFields = Array.isArray(this.patientCreationModelMap)
            ? this.patientCreationModelMap
            : [];

        const customDynamicFields = patientCreationFields.reduce((acc: Record<string, any>, field: any) => {
            const fieldKey = this.getFieldBindingKey(field);
            if (!fieldKey || this.isStandardPatientField(field)) {
                return acc;
            }

            const value = this.getCustomDynamicFieldConfigValue(field);
            if (value !== undefined && value !== null && value !== '') {
                acc[fieldKey] = value;
            }

            return acc;
        }, {});

        const patientCreationPayload: any = this.cleanObject({
            externalId: this.patientInformationObject.patientInfo.externalId,
            firstName: this.patientInformationObject.patientInfo.firstName,
            middleName: this.patientInformationObject.patientInfo.middleName,
            lastName: this.patientInformationObject.patientInfo.lastName,
            dateOfBirth:
                this.dateOfBirthObject?.dobMonth &&
                this.dateOfBirthObject?.dobDay &&
                this.dateOfBirthObject?.dobYear
                    ? `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`
                    : null,
            gender: this.patientInformationObject.patientInfo.gender,
            cellPhone: this.formatPhoneNumber(
                this.patientInformationObject.patientInfo.cellPhone,
            ),
            homePhone: this.formatPhoneNumber(
                this.patientInformationObject.patientInfo.homePhone,
            ),
            email: this.patientInformationObject.patientInfo.email,
            address: this.patientInformationObject.patientInfo.address,
            healthPlan: this.patientInformationObject.patientInfo.healthPlan,
            memberId: this.patientInformationObject.patientInfo.memberId,
            language: this.patientInformationObject.patientInfo.language,
            leadSource: this.patientInformationObject.patientInfo.leadSource,
            callSource: this.patientInformationObject.patientInfo.callSource,
        });

        if (Object.keys(customDynamicFields).length > 0) {
            patientCreationPayload.additionalFields = customDynamicFields;
        }

        this.patientDetailsAddObj = patientCreationPayload;
    }

    createPatient(){
          this.createNewPatientService
                                    .createNewPatient(this.patientDetailsAddObj)
                                    .then((resultData: any) => {
                                        if (!resultData) {
                                            return;
                                        }
                                        const createdPatientId = resultData.data?.patientId
                                        const result: createNewPatient = {
                                            data: {
                                                ...(resultData.data || {}),
                                                orgEntityId: createdPatientId,
                                            },
                                            isAlreadyPresent: Boolean( resultData.success) || false,
                                        };
                                        const finishCreate = () => {
                                            this.loader = false;
                                            this.toastr.success(
                                                'Member created successfully.',
                                            );
                                            if (this.showBackToSearchBtn) {
                                                this.dialogRef.close({
                                                    success: true,
                                                    orgEntityId: createdPatientId,
                                                    associateWithNewPatient:
                                                        result,
                                                });
                                            } else {
                                                this.dialogRef.close({
                                                    success: true,
                                                    orgEntityId: createdPatientId,
                                                });
                                            }
                                        };

                                        if (createdPatientId) {
                                            this.inboxService
                                                .postPatientVisit({
                                                    patientId: createdPatientId,
                                                })
                                                .subscribe({
                                                    next: () => finishCreate(),
                                                    error: () => finishCreate(),
                                                });
                                        } else {
                                            finishCreate();
                                        }
                                    })
                                    .catch((ex: any) => {
                                        console.log(ex);
                                        this.toastr.error(
                                            ex.error?.message ||
                                                ex?.error?.Error ||
                                                'Unknown error occurred. Please contact administrator.',
                                        );
                                        this.loader = false;
                                    });
    }

    // Only AlphaNumeric
    keyPressAlphaNumeric(event: any , type?: string) {
        var inp = String.fromCharCode(event.keyCode);
        if (type === 'number') {
            if (/^[0-9]$/.test(inp)) {
                return true;
            } else {
                event.preventDefault();
                return false;
            }
        }
        if (/^[a-zA-Z0-9]+$/.test(inp)) {
            return true;
        }else if(type == 'alphanumeric' && (/^[a-zA-Z0-9 ]+$/.test(inp))){
             return true;
        }else if(type == 'alpha' && (/^[a-zA-Z ]$/.test(inp))){
             return true;
        } else {
            event.preventDefault();
            return false;
        }
    }

    backToSearch() {
        this.dialogRef.close({ goBackToSearch: true });
    }
    onPaste(event: ClipboardEvent, type?: string) {
        event.preventDefault();
        let pastedText = event.clipboardData?.getData('text/plain') || '';
        let digits = pastedText.replace(/\D/g, '');
        if (digits.length === 11 && digits.startsWith('1')) {
            digits = digits.slice(1);
        }
        digits = digits.slice(0, 10);
        let formatted = '';
        if (digits.length === 10) {
            formatted = `+1 ${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
        } else {
            formatted = `+1 ${digits}`;
        }
        const input = event.target as HTMLInputElement;

         if (type === 'number') {
            let digits = pastedText.replace(/\D/g, '');
            digits = digits.slice(0, 9);
            input.value = digits;
        }else{
            input.value = formatted;
        }
        input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    showBackToSearchBtn: boolean = true;
    ngOnInit(): void {
        if (this.data && this.data.showBackToSearch) {
            this.showBackToSearchBtn = true;
        }
        if (this.data.patientDetails) {
            const patientData = this.data.patientDetails as any;
            const patientAddress =
                patientData.address && typeof patientData.address === 'object'
                    ? patientData.address
                    : {};

            this.patientInformationObject.patientInfo.firstName =
                patientData.firstName ||
                '';
            this.patientInformationObject.patientInfo.middleName =
                patientData.middleName ||
                '';
            this.patientInformationObject.patientInfo.lastName =
                patientData.lastName ||
                '';

            const dateOfBirthValue =
                patientData.dateOfBirth ||
                patientData.patientDob ||
                patientData.dob ||
                '';
            if (dateOfBirthValue) {
                const [month, day, year] = String(dateOfBirthValue).split('/');
                // A stored date that is not a real calendar date (e.g. 00/00/0000) is left blank so it can be re-entered.
                if (isValidCalendarDate(month, day, year)) {
                    // Month/day must stay zero-padded strings ('06'), the ids of the dropdown options.
                    this.dateOfBirthObject.dobMonth = month.padStart(2, '0') as any;
                    this.setDays();
                    this.dateOfBirthObject.dobDay = day.padStart(2, '0') as any;
                    this.dateOfBirthObject.dobYear = year;
                } else {
                    this.isStoredDobNotPrefilled = true;
                }
                this.patientInformationObject.patientInfo.dateOfBirth =
                    dateOfBirthValue;
            }

            this.patientInformationObject.patientInfo.externalId =
                patientData.externalId ||
                patientData.patientExternalId ||
                patientData.medicalRecordNumber ||
                patientData.patientId ||
                '';
            this.patientInformationObject.patientInfo.gender =
                patientData.birthGender || patientData.gender || '';
            this.patientInformationObject.patientInfo.homePhone =
                patientData.patientHomePhoneNumber ||
                patientData.homePhone ||
                patientData.patientHomePhone ||
                '';
            this.patientInformationObject.patientInfo.cellPhone =
                patientData.patientPhoneNumber ||
                patientData.cellPhone ||
                patientData.phoneNumber ||
                '';
            this.patientInformationObject.patientInfo.email =
                patientData.patientEmail || patientData.email || '';
            this.patientInformationObject.patientInfo.address.addressLine1 =
                patientData.addressLine1 ||
                patientAddress.addressLine1 ||
                patientData.patientAddress?.addressLine1 ||
                '';
            this.patientInformationObject.patientInfo.address.addressLine2 =
                patientData.addressLine2 ||
                patientAddress.addressLine2 ||
                patientData.patientAddress?.addressLine2 ||
                '';
            this.patientInformationObject.patientInfo.address.city =
                patientData.city || patientAddress.city || '';
            this.patientInformationObject.patientInfo.address.postalCode =
                patientData.postalCode || patientAddress.postalCode || '';
            this.patientInformationObject.patientInfo.address.stateOrProvinceCode =
                patientData.stateOrProvinceCode ||
                patientAddress.stateOrProvinceCode ||
                patientData.stateCode ||
                '';
            this.patientInformationObject.patientInfo.address.timezone =
                patientData.timezone ||
                this.data.additionalDetailsEmittedValue?.timeZone ||
                '';
            this.patientInformationObject.patientInfo.healthPlan =
                patientData.planName || patientData.healthPlan || '';
            this.patientInformationObject.patientInfo.language =
                patientData.preferredLanguage || patientData.language || '';
            this.patientInformationObject.patientInfo.leadSource =
                patientData.leadSource || '';
            this.patientInformationObject.patientInfo.callSource =
                patientData.callSource || '';
        }
        this.getCodeValueByCategoryIdAddressTimezone = this.api
            .getCodeValueByCategoryId(
                reservedCodeCategories.reservedCodeCategoryUnitedStatesTimezoneId,
            )
            .subscribe({
                next: (result: getCodeValueByCategoryIdResult) => {
                    this.addressTimezone = result.data.sort(
                        (
                            a: { valueShortDescription: string },
                            b: { valueShortDescription: string },
                        ) =>
                            a.valueShortDescription.localeCompare(
                                b.valueShortDescription,
                            ),
                    );
                },
                error: (error: HttpErrorResponse) => {
                    console.log('An Error Occurred', error);
                },
            });
        this.localService.broadCastPermissions$.subscribe((value) => {
            const focusBrandConfiguration =
                value?.focusBrandConfiguration?.patientCreationModelConfig ||
                [];
            this.isPatientCreationModelEnabled =
                focusBrandConfiguration?.isConfigEnabled || false;
            if (
                focusBrandConfiguration?.fields &&
                focusBrandConfiguration?.fields.length > 0 &&
                focusBrandConfiguration?.isConfigEnabled
            ) {
                this.patientCreationModelMap = Array.isArray(
                    focusBrandConfiguration.fields,
                )
                    ? focusBrandConfiguration.fields
                    : [];

                this.ensureCategoryIdsForConfiguredDropdowns();
                this.getCodeValuesByCategory();
            }
        });

        if (this.data.editPatient) {
            this.setEditGeneralDetailsConfig();
            this.data.patientAdditionalFields.columns.forEach((col) => {
                this.formData[col.dataProperty] = this.data
                    .additionalDetailsEmittedValue
                    ? this.data.additionalDetailsEmittedValue[col.dataProperty]
                    : '';
                if (col.type == 'NUMERIC(PHONE)') {
                    const rawPhoneValue = this.data.additionalDetailsEmittedValue
                        ? this.data.additionalDetailsEmittedValue[
                              col.dataProperty
                          ]
                        : '';
                    const phoneValue = rawPhoneValue
                        ? rawPhoneValue.toString()
                        : '';

                    this.formData[col.dataProperty] = phoneValue
                        ? phoneValue.replace(
                              /^(\+?1)?(\d{3})(\d{3})(\d{4})$/,
                              '+1 $2-$3-$4',
                          )
                        : '';
                }
                if (
                    this.isPatientUsernameField(col) &&
                    !this.isPatientUsernameValidTenDigitNumber(col)
                ) {
                    this.formData[col.dataProperty] = '';
                }
                if(col.dataProperty == 'digitalConsent'){
                    if (this.data && this.data.additionalDetailsEmittedValue) {
                        if(this.data.additionalDetailsEmittedValue['digitalConsent'] == 1){
                            this.formData['digitalConsent'] = 'Yes';
                        }else if(this.data.additionalDetailsEmittedValue['digitalConsent'] == 0){
                            this.formData['digitalConsent'] = 'No';
                        }else{
                            this.formData['digitalConsent'] = '';
                        }
                    } else {
                        this.formData['digitalConsent'] = '';
                    }
                }
                if(col.dataProperty == 'medicarePrescriptionPaymentPlan'){
                    if (this.data?.patientDetails && this.data.patientDetails['medicarePrescriptionPaymentPlan'] !== undefined) {
                        if (this.data.patientDetails['medicarePrescriptionPaymentPlan'] == 0) {
                            this.formData['medicarePrescriptionPaymentPlan'] = '';
                        }
                    }
                }
                if (col.type == 'DROPDOWN') {
                    if (col.dataProperty == 'timeZone') {
                        this.categoryIds.push(
                            reservedCodeCategories.reservedCodeCategoryUnitedStatesTimezoneId,
                        );
                    } else if (col.dataProperty == 'enrollmentStatus') {
                        this.categoryIds.push(
                            reservedCodeCategories.reservedCodeCategoryPatientEnrollmentStatusId,
                        );
                    }
                }
            });

            this.groupedAdditionalFields = groupFieldsByNearestName(
                this.data.patientAdditionalFields.columns,
            );
        }

        this.categoryIds.push(reservedCodeCategories.reservedCodeCategoryPreferredlanguageId); // language
        this.categoryIds.push(reservedCodeCategories.reservedCodeCategoryPatientLeadSourceId); // lead source
        this.categoryIds.push(reservedCodeCategories.reservedCodeCategoryPatientHealthPlanId); // healthPlan
        this.categoryIds.push(reservedCodeCategories.reservedCodeCategoryPatientCallSourceId); // call source

        this.ensureCategoryIdsForConfiguredDropdowns();
        this.getCodeValuesByCategory();
        this.captureInitialSnapshot();  
    }
    ngOnChanges(): void {
        this.data.stateList = this.data.stateList;
    }

    private buildSnapshot(): string {
        return JSON.stringify({
            patientInfo: this.patientInformationObject.patientInfo,
            dob: this.dateOfBirthObject,
            additional: this.formData,
        });
    }

    captureInitialSnapshot(): void {
        this.initialFormSnapshot = this.buildSnapshot();
        this.initialEditValues = JSON.parse(this.initialFormSnapshot);
    }

    get isFormChanged(): boolean {
        return !!this.initialFormSnapshot &&
               this.initialFormSnapshot !== this.buildSnapshot();
    }

    private normalizeForCompare(value: any): any {
        if (value === null || value === undefined) {
            return '';
        }
        return typeof value === 'string' ? value.trim() : value;
    }

    private isFieldChanged(currentValue: any, originalValue: any): boolean {
        return (
            this.normalizeForCompare(currentValue) !==
            this.normalizeForCompare(originalValue)
        );
    }

    private isBlankValue(value: any): boolean {
        return this.normalizeForCompare(value) === '';
    }

    /** Omitting an unchanged key makes the backend skip it, so untouched Org Entity records are never rewritten. */
    private assignIfChanged(
        target: Record<string, any>,
        key: string,
        currentValue: any,
        originalValue: any,
    ): void {
        if (!this.data?.editPatient || !this.initialEditValues) {
            target[key] = currentValue;
            return;
        }
        if (this.isFieldChanged(currentValue, originalValue)) {
            target[key] = currentValue;
        }
    }

    /**
     * Contact fields are also sent when unchanged but non-blank, so the API's
     * "at least one contact method" rule still sees the patient's real contact state.
     * An identical value is a no-op server side.
     */
    private assignContactField(
        target: Record<string, any>,
        key: string,
        currentValue: any,
        originalValue: any,
    ): void {
        if (!this.data?.editPatient || !this.initialEditValues) {
            target[key] = currentValue;
            return;
        }
        if (
            this.isFieldChanged(currentValue, originalValue) ||
            !this.isBlankValue(currentValue)
        ) {
            target[key] = currentValue;
        }
    }
    updatePatientDetails() {
        if (!this.isFormChanged) {                        // <-- add
            this.toastr.info('No changes to update.');
            return;
        }
        if (
            this.dateOfBirthObject.dobMonth &&
            this.dateOfBirthObject.dobDay &&
            this.dateOfBirthObject.dobYear
        ) {
            this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
        } else {
            // An unparsable stored DOB is kept as-is so an unrelated edit does not erase it.
            this.patientInformationObject.patientInfo.dateOfBirth =
                this.isStoredDobNotPrefilled
                    ? this.initialEditValues?.patientInfo?.dateOfBirth ?? ''
                    : '';
        }
        this.patientInformationObject.patientInfo.address.stateOrProvinceCode =
            this.patientInformationObject.patientInfo.address
                .stateOrProvinceCode
                ? this.patientInformationObject.patientInfo.address
                      .stateOrProvinceCode
                : '';
        const patientInfo = this.patientInformationObject.patientInfo;
        const originalInfo = this.initialEditValues?.patientInfo || {};
        const editPatient: any = {};

        this.assignIfChanged(
            editPatient,
            'firstName',
            patientInfo.firstName?.trim() || '',
            originalInfo.firstName?.trim() || '',
        );
        this.assignIfChanged(
            editPatient,
            'middleName',
            patientInfo.middleName?.trim() || '',
            originalInfo.middleName?.trim() || '',
        );
        this.assignIfChanged(
            editPatient,
            'lastName',
            patientInfo.lastName?.trim() || '',
            originalInfo.lastName?.trim() || '',
        );
        this.assignIfChanged(
            editPatient,
            'externalId',
            patientInfo.externalId?.trim() || '',
            originalInfo.externalId?.trim() || '',
        );
        this.assignIfChanged(
            editPatient,
            'dateOfBirth',
            patientInfo.dateOfBirth?.trim() || '',
            originalInfo.dateOfBirth?.trim() || '',
        );
        this.assignContactField(
            editPatient,
            'cellPhone',
            this.formatPhoneNumber(patientInfo.cellPhone) || '',
            this.formatPhoneNumber(originalInfo.cellPhone) || '',
        );
        this.assignContactField(
            editPatient,
            'homePhone',
            this.formatPhoneNumber(patientInfo.homePhone) || '',
            this.formatPhoneNumber(originalInfo.homePhone) || '',
        );
        this.assignContactField(
            editPatient,
            'email',
            patientInfo.email?.trim() || '',
            originalInfo.email?.trim() || '',
        );

        const changedAddress = this.getChangedAddressPayload();
        const additionalDetails = this.getEditGeneralDetailsPayload();
        if (
            this.data &&
            this.data.patientAdditionalFields &&
            Array.isArray(this.data.patientAdditionalFields.columns)
        ) {
            this.data.patientAdditionalFields.columns.forEach((col) => {
                if (
                    this.isPatientUsernameField(col) &&
                    !this.isPatientUsernameValidTenDigitNumber(col)
                ) {
                    return;
                }

                const colName = col.dataProperty;
                if (colName && this.formData.hasOwnProperty(colName)) {
                    const val = this.formData[colName];
                    let outgoingValue: any;
                    if (val !== undefined && val !== null) {
                        if (col.type == 'NUMERIC(PHONE)') {
                            outgoingValue = this.formatPhoneNumber(val);
                        } else if (col.type == 'BOOLEAN') {
                            outgoingValue = !!val;
                        } else {
                            outgoingValue = typeof val === 'string' ? val.trim() : val;
                        }
                    } else {
                        outgoingValue = '';
                    }
                    this.assignIfChanged(
                        additionalDetails,
                        colName,
                        outgoingValue,
                        this.getOriginalAdditionalFieldValue(col),
                    );
                }
            });
        }
        if (Object.keys(additionalDetails).length) {
            editPatient.additionalDetails = additionalDetails;
        }
        if (
            changedAddress &&
            (Object.keys(changedAddress).length ||
                'timeZone' in additionalDetails)
        ) {
            editPatient.address = changedAddress;
        }
        if (this.validUpdateRequiredFields()) {
            if (editPatient.address) {
                Object.keys(editPatient.address).forEach((key) => {
                    editPatient.address[key] =
                        editPatient.address[key]?.trim() || null;
                });
            }
            this.loader = true;
            this.createNewPatientService
                .updatePatientDetails(editPatient, this.data.orgEntityId)
                .subscribe({
                    next: (result: any) => {
                        this.loader = false;
                        if (result) {
                            this.toastr.success(
                                'Patient Details updated successfully.',
                            );
                            this.dialogRef.close({ success: true });
                        }
                    },
                    error: (error: any) => {
                        this.loader = false;
                        this.toastr.error(
                            error.error?.message ||
                                error?.error?.Error ||
                                'Something went error',
                        );
                    },
                });
        }
    }

    searchByMRN(event?: any, saveValue?: string) {
        if (this.data.editPatient) {
            if (event) {
                this.patientInformationObject.patientInfo.externalId =
                    event.target.value;
            }
            if (this.patientInformationObject.patientInfo.externalId) {
                this.createNewPatientService
                    .searchByMRN(
                        this.patientInformationObject.patientInfo.externalId,
                    )
                    .subscribe({
                        next: (result: any) => {
                            if (result && result.data) {
                                // let dialogData = {
                                //     newValues: result.data,
                                //     existingValues:
                                //         this.patientInformationObject.patientInfo,
                                //     orgEntityId: this.data.orgEntityId,
                                //     stateList:this.data.stateList
                                // }
                                // const openDialog = () => {
                                //     const dialogRef = this.dialog.open(
                                //         PatientDetailMergeModalComponent,
                                //         {
                                //             disableClose: false,
                                //             data: dialogData,
                                //             width: '1200px',
                                //         },
                                //     )
                                //     dialogRef.afterClosed().subscribe(result => {
                                //         if (result.success) {
                                //             this.dialogRef.close({success: true, orgEntityId: result.orgEntityId});
                                //         }
                                //     });
                                // }

                                // openDialog()
                                this.toastr.warning(
                                    this.getAlreadyExistsPatientIdMessage(),
                                );
                            } else {
                                if (saveValue == 'save') {
                                    this.data.patientDetails.externalId =
                                        event.target.value;
                                    this.updatePatientDetails();
                                } else {
                                    const patientIdLabel =
                                        this.getPatientIdLabel();
                                    this.toastr.success(
                                        `${patientIdLabel} does not exist. You can continue with this ${patientIdLabel}.`,
                                    );
                                }
                            }
                        },
                        error: (error) => {
                            this.toastr.error(
                                error.error?.message ||
                                    error?.error?.Error ||
                                    'Something went error',
                            );
                        },
                    });
            } else {
                this.toastr.warning(
                    `Please enter ${this.getPatientIdLabel()}`,
                );
            }
        }
    }

     private validateAdditionalFields(): boolean {
    if (
      !this.data ||
      !this.data.patientAdditionalFields ||
      !this.data.patientAdditionalFields.isAdditionalFieldsEnabled ||
      !Array.isArray(this.data.patientAdditionalFields.columns)
    ) {
      return true;
    }

    const errors: string[] = [];
    for (const col of this.data.patientAdditionalFields.columns) {
            if (
                this.isPatientUsernameField(col) &&
                !this.isPatientUsernameValidTenDigitNumber(col)
            ) {
                continue;
            }

    const isReq = this.isFieldRequired(col) && this.isAdditionalFieldEditable(col);
      const prop = col.dataProperty;
      let val: any = undefined;
      if (prop && this.formData && Object.prototype.hasOwnProperty.call(this.formData, prop)) {
        val = this.formData[prop];
      }
      if ((val === undefined || val === null || val === '') && prop) {
        val = (this.patientInformationObject.patientInfo as any)[prop];
      }
      const empty =
        val === undefined ||
        val === null ||
        (typeof val === 'string' && val.trim() === '') ||
        (Array.isArray(val) && val.length === 0);
        const label = col.columnName || prop || 'Field';
      if (empty && isReq && !(prop === 'leadStatus' || prop === 'statusDetail')) {
        errors.push(`${label} is required.`);
      }

       const type = col.type;

            if ( val && prop &&
                (type == 'NUMERIC(PHONE)')
            ) {
                const cleaned = this.cleanPhoneNumber(val as string);
                if (!cleaned || cleaned.length !== 15 || !this.phoneRegex.test(cleaned)) {
                    errors.push(`${label} is not a valid phone number.`);
                }
            }
            if (val &&  prop &&
                (type == 'ALPHANUMERIC(EMAIL)')
            ) {
                if (typeof val === 'string' && val.length > 0 && !this.emailRegex.test(val)) {
                    errors.push(`${label} is not a valid email address.`);
                }
            }
    }

    if (errors.length > 0) {
      errors.forEach(error => this.toastr.warning(error));
      return false;
    }

    return true;
    }
    validUpdateRequiredFields() {
        this.isValid = true;
        if (!this.validateEditRequiredFields()) {
            this.isValid = false;
        }
        const existingExternalId = this.data?.patientDetails?.externalId;
        const enteredExternalId =
            this.patientInformationObject?.patientInfo?.externalId?.trim() ||
            '';
        const hasAnyDobValue = !!(
            this.dateOfBirthObject?.dobMonth ||
            this.dateOfBirthObject?.dobDay ||
            this.dateOfBirthObject?.dobYear
        );
        let isLeapYear =
            parseInt(this.dateOfBirthObject.dobYear) % 100 === 0
                ? parseInt(this.dateOfBirthObject.dobYear) % 400 === 0
                : parseInt(this.dateOfBirthObject.dobYear) % 4 === 0;

        if (
            this.data?.editPatient &&
            existingExternalId &&
            !enteredExternalId
        ) {
            const patientIdLabel = this.getPatientIdLabel();
            this.toastr.warning(
                `${patientIdLabel} cannot be empty for patients with an existing ${patientIdLabel}`,
            );
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.firstName.length > 60
        ) {
            this.toastr.warning(`First name should be less than 60 characters`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.middleName.length > 60
        ) {
            this.toastr.warning(
                `Middle name should be less than 60 characters`,
            );
            this.isValid = false;
        }
        // else if (
        //     this.patientInformationObject.patientInfo &&
        //     (this.patientInformationObject.patientInfo.middleName ||
        //         this.patientInformationObject.patientInfo.middleName?.trim())
        //         &&
        //     !this.nameRegex.test(
        //         this.patientInformationObject.patientInfo.middleName,
        //     )
        // ) {
        //     this.toastr.warning(`Please enter valid Middle Name`);
        //     this.isValid = false;
        // }
        else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.lastName.length > 60
        ) {
            this.toastr.warning(`Last name should be less than 60 characters`);
            this.isValid = false;
        }
        // else if (
        //     this.patientInformationObject.patientInfo &&
        //     (this.patientInformationObject.patientInfo.firstName ||
        //         this.patientInformationObject.patientInfo.firstName?.trim())
        //          &&
        //      !this.nameRegex.test(
        //          this.patientInformationObject.patientInfo.firstName,
        //      )
        // ) {
        //     this.toastr.warning(`Please enter valid First Name`);
        //     this.isValid = false;
        // }
        // else if (
        //     this.patientInformationObject.patientInfo &&
        //     (this.patientInformationObject.patientInfo.lastName ||
        //         this.patientInformationObject.patientInfo.lastName?.trim())
        //         &&
        //     !this.nameRegex.test(
        //         this.patientInformationObject.patientInfo.lastName,
        //     )
        // ) {
        //     this.toastr.warning(`Please enter valid Last Name`);
        //     this.isValid = false;
        // }
        else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.cellPhone &&
            (this.patientInformationObject.patientInfo.cellPhone.length !==
                15 ||
                !this.phoneRegex.test(
                    this.patientInformationObject.patientInfo.cellPhone,
                ))
        ) {
            this.toastr.warning(`Please enter valid cell Number`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            !this.patientInformationObject.patientInfo.cellPhone &&
            (!this.patientInformationObject.patientInfo.email ||
                !this.patientInformationObject.patientInfo.email?.trim())
        ) {
            this.toastr.warning(
                'Either Cell Phone or Email Address is required',
            );
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.homePhone &&
            (this.patientInformationObject.patientInfo.homePhone.length !==
                15 ||
                !this.phoneRegex.test(
                    this.patientInformationObject.patientInfo.homePhone,
                ))
        ) {
            this.toastr.warning(`Please enter valid home Number`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.email &&
            !this.emailRegex.test(
                this.patientInformationObject.patientInfo.email,
            )
        ) {
            this.toastr.warning(`Enter a valid Confidential Email`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.email &&
            this.patientInformationObject.patientInfo.email.trim().length > 100
        ) {
            this.toastr.warning(
                `Email address should be less than 100 characters`,
            );
            this.isValid = false;
        } else if (hasAnyDobValue && this.dateOfBirthObject && !this.dateOfBirthObject.dobMonth) {
            this.toastr.warning(`Please enter your DOB Month`);
            this.isValid = false;
        } else if (hasAnyDobValue && this.dateOfBirthObject && !this.dateOfBirthObject.dobDay) {
            this.toastr.warning(`Please enter your DOB Day`);
            this.isValid = false;
        } else if (hasAnyDobValue && this.dateOfBirthObject && !this.dateOfBirthObject.dobYear) {
            this.toastr.warning(`Please enter your DOB Year`);
            this.isValid = false;
        } else if (this.data?.editPatient) {
            const usernameColumn = this.data?.patientAdditionalFields?.columns?.find(
                (col) => this.isPatientUsernameField(col)
            );

            if(usernameColumn) {
                const existingUsername = this.getPatientUsernameFieldValue(usernameColumn);
                const enteredUsername = (this.formData[usernameColumn.dataProperty] || '').toString().trim();
                const normalizedEnteredUsername = this.formatPhoneNumber(enteredUsername);
                const validExistingUsername = this.isValidPhoneUsername(existingUsername);

                if(validExistingUsername && !normalizedEnteredUsername) {
                    this.toastr.warning('Patient Username is required.');
                    this.isValid = false;
                }

                const patientUsernameRegex = /^\d{10}$/;
                if (normalizedEnteredUsername && !patientUsernameRegex.test(normalizedEnteredUsername)) {
                    this.toastr.warning('Please enter valid patient username.');
                    this.isValid = false;
                }
            }
        } 
        
        else if (
            this.isValid &&
            hasAnyDobValue &&
            this.dateOfBirthObject.dobMonth &&
            this.dateOfBirthObject.dobDay &&
            this.dateOfBirthObject.dobYear
        ) {
            if (
                this.dateOfBirthObject.dobMonth < 10 &&
                this.dateOfBirthObject.dobDay >= 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
            } else if (
                this.dateOfBirthObject.dobDay < 10 &&
                this.dateOfBirthObject.dobMonth >= 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
            } else if (
                this.dateOfBirthObject.dobDay < 10 &&
                this.dateOfBirthObject.dobMonth < 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
            } else {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
            }
            var date = moment(
                this.patientInformationObject.patientInfo.dateOfBirth,
            );
            if (date.isValid()) {
                var currentDateTime = new Date();
                var expirationDateTime = new Date(
                    this.patientInformationObject.patientInfo.dateOfBirth,
                );
                if (expirationDateTime.getTime() > new Date().getTime()) {
                    this.toastr.warning(
                        "Birth date can't be greater than or equal to the current date",
                    );
                    this.isValid = false;
                } else if (+this.dateOfBirthObject.dobYear < 1900) {
                    this.toastr.warning(
                        'Birth year should be greater than or equal to 1900.',
                    );
                    this.isValid = false;
                } else if (
                    expirationDateTime.getMonth() ===
                        currentDateTime.getMonth() &&
                    expirationDateTime.getFullYear() ===
                        currentDateTime.getFullYear() &&
                    expirationDateTime.getDate() === currentDateTime.getDate()
                ) {
                    this.toastr.warning(
                        "Birth date can't be greater than or equal to the current date",
                    );
                    this.isValid = false;
                } else if (
                    this.dateOfBirthObject.dobMonth.toString() == '02' &&
                    this.dateOfBirthObject.dobDay > 28 &&
                    !isLeapYear
                ) {
                    this.toastr.warning('Invalid birth date');
                    this.isValid = false;
                } else {
                    this.isValid = true;
                }
            } else {
                this.toastr.warning('Date of birth is invalid');
                this.isValid = false;
            }
        }
        if (this.isValid) {
            const dobError = this.getDobError();
            if (dobError) {
                this.toastr.warning(dobError);
                this.isValid = false;
            }
        }
        if (!this.validateAdditionalFields()) {
           this.isValid = false;
           }
        if (
            this.patientInformationObject.patientInfo?.address?.postalCode &&
            this.patientInformationObject.patientInfo.address.postalCode.trim() !== '' &&
            this.patientInformationObject.patientInfo.address.postalCode.trim().length !== 5 &&
            this.patientInformationObject.patientInfo.address.postalCode.trim().length !== 9
        ) {
             this.toastr.warning(`Zip Code must be 5 or 9 digits`);
            this.isValid = false;
        }

        return this.isValid;
    }

    private validateEditRequiredFields(): boolean {
        const requiredFields: Set<string> = this.editGeneralDetailsConfigPresent
            ? this.editGeneralDetailsRequiredFields
            : new Set<string>();

        if (!this.data?.editPatient || !requiredFields.size) {
            return true;
        }

        const getValue = (fieldKey: string): any => {
            switch (fieldKey) {
                case 'patientId':
                    return this.patientInformationObject.patientInfo.externalId;
                case 'firstName':
                    return this.patientInformationObject.patientInfo.firstName;
                case 'middleName':
                    return this.patientInformationObject.patientInfo.middleName;
                case 'lastName':
                    return this.patientInformationObject.patientInfo.lastName;
                case 'dateOfBirth':
                    return this.dateOfBirthObject?.dobMonth &&
                        this.dateOfBirthObject?.dobDay &&
                        this.dateOfBirthObject?.dobYear
                        ? `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`
                        : '';
                case 'gender':
                    return this.patientInformationObject.patientInfo.gender;
                case 'email':
                    return this.patientInformationObject.patientInfo.email;
                case 'cellPhone':
                    return this.patientInformationObject.patientInfo.cellPhone;
                case 'homePhone':
                    return this.patientInformationObject.patientInfo.homePhone;
                case 'address': {
                    const address = this.patientInformationObject.patientInfo.address;
                    return (
                        address?.addressLine1 &&
                        address?.city &&
                        address?.stateOrProvinceCode &&
                        address?.postalCode
                    );
                }
                case 'preferredLanguage':
                    return this.patientInformationObject.patientInfo.language;
                case 'timezone':
                    return this.patientInformationObject.patientInfo.address?.timezone;
                case 'healthPlan':
                    return this.patientInformationObject.patientInfo.healthPlan;
                case 'leadSource':
                    return this.patientInformationObject.patientInfo.leadSource;
                case 'callSource':
                    return this.patientInformationObject.patientInfo.callSource;
                default:
                    return true;
            }
        };

        const labelMap: Record<string, string> = {
            patientId: this.getPatientIdLabel(),
            firstName: 'First Name',
            middleName: 'Middle Name',
            lastName: 'Last Name',
            dateOfBirth: 'Date of Birth',
            gender: 'Gender',
            email: 'Email Address',
            cellPhone: 'Cell Phone',
            homePhone: 'Home Phone',
            address: 'Address',
            preferredLanguage: 'Preferred Language',
            timezone: 'Time Zone',
            healthPlan: 'Health Plan',
            leadSource: 'Lead Source',
            callSource: 'Call Source',
        };

        for (const fieldKey of requiredFields) {
            if (!this.isEditable(fieldKey, 'edit')) {
                continue;
            }
            const value = getValue(fieldKey);
            const isEmpty =
                value === undefined ||
                value === null ||
                (typeof value === 'string' && value.trim() === '') ||
                value === false;
            if (isEmpty) {
                this.toastr.warning(`Please enter ${labelMap[fieldKey] || fieldKey}`);
                return false;
            }
        }

        return true;
    }
    ngOnDestroy(): void {
        this.getCodeValueByCategoryIdAddressTimezone.unsubscribe();
    }
    hasField(label: string, edit?: string, create?: string) {
        const canonicalLabel = this.getCanonicalGeneralDetailsKey(label);

        if (edit && this.data.editPatient == true) {
            if (this.editGeneralDetailsConfigPresent) {
                return this.editGeneralDetailsVisibleFields.has(canonicalLabel);
            }
            return true;
        } else if (
            this.patientCreationModelMap &&
            this.patientCreationModelMap.length > 0 &&
            this.data.editPatient == false &&
            this.isPatientCreationModelEnabled == true
        ) {
            return !!this.getCreateFieldConfig(label);
        } else if (this.data.editPatient == false && create &&
            this.isPatientCreationModelEnabled == false){
            return true;
        }else{
            return false;
        }
    }
    isRequired(label: string, mode?: 'edit' | 'create'): boolean {
        const canonicalLabel = this.getCanonicalGeneralDetailsKey(label);
        const isEditMode = mode ? mode === 'edit' : this.data.editPatient === true;

         if(isEditMode){
            if (!this.editGeneralDetailsConfigPresent) {
                return false;
            }
            return this.editGeneralDetailsRequiredFields.has(canonicalLabel);
        }
        if (
            this.isPatientCreationModelEnabled &&
            this.patientCreationModelMap &&
            this.patientCreationModelMap.length > 0
        ) {
            const createFieldConfig = this.getCreateFieldConfig(label);
            return !!createFieldConfig && this.isFieldRequired(createFieldConfig);
        }
        return false;
    }

    private matchesConfiguredField(field: any, label: string): boolean {
        const candidate = this.getCanonicalGeneralDetailsKey(label);
        const configValues = [
            field?.label,
            field?.dataProperty,
            field?.displayName,
            field?.columnName,
            field?.columnValue,
            field?.name,
        ]
            .filter((value) => value !== null && value !== undefined && value !== '')
            .map((value) => this.getCanonicalGeneralDetailsKey(value));

        return configValues.includes(candidate) || configValues.includes(this.normalizeGeneralDetailsKey(label));
    }

    isStandardPatientField(field: any): boolean {
        const fieldKey = this.getFieldBindingKey(field);
        if (!fieldKey) {
            return false;
        }

        const standardKeys = [
            'patientId',
            'firstName',
            'middleName',
            'lastName',
            'gender',
            'dateOfBirth',
            'cellPhone',
            'homePhone',
            'email',
            'address',
            'healthPlan',
            'preferredLanguage',
            'timezone',
            'leadSource',
            'callSource',
        ];

        return standardKeys.some(
            (key) =>
                this.getCanonicalGeneralDetailsKey(key) ===
                this.getCanonicalGeneralDetailsKey(fieldKey),
        );
    }

    getDynamicPatientCreationFields(): any[] {
        if (!this.isPatientCreationModelEnabled || !Array.isArray(this.patientCreationModelMap)) {
            return [];
        }

        return this.patientCreationModelMap.filter((field: any) => {
            const key = this.getFieldBindingKey(field);
            if (!key || this.isStandardPatientField(field)) {
                return false;
            }
            return true;
        });
    }

    getFieldBindingKey(field: any): string {
        return (
            field?.dataProperty ||
            field?.label ||
            field?.displayName ||
            field?.columnName ||
            field?.columnValue ||
            field?.name ||
            ''
        );
    }

    getFieldDisplayName(field: any): string {
        return (
            field?.displayName ||
            field?.columnName ||
            field?.label ||
            field?.dataProperty ||
            'Field'
        );
    }

    getFieldValue(field: any): any {
        const key = this.getFieldBindingKey(field);
        if (!key) {
            return '';
        }
        return (this.patientInformationObject.patientInfo as any)[key] ?? '';
    }

    getCustomDynamicFieldConfigValue(field: any): any {
        const key = this.getFieldBindingKey(field);
        if (!key || this.isStandardPatientField(field)) {
            return undefined;
        }
        return (this.patientInformationObject.patientInfo as any)[key];
    }

    setFieldValue(field: any, value: any): void {
        const key = this.getFieldBindingKey(field);
        if (!key) {
            return;
        }
        (this.patientInformationObject.patientInfo as any)[key] = value;
    }

    getFieldOptions(field: any): any[] {
        const fieldKey = this.getFieldBindingKey(field);
        if (!fieldKey) {
            return [];
        }

        if (field?.options && Array.isArray(field.options)) {
            return field.options;
        }

        if (fieldKey === 'preferredApptReminderMethod') {
            return this.preferredApptReminderMethodArray;
        }

        return this.getDropDownList(fieldKey) || [];
    }

    private getCreateFieldConfig(label: string): any {
        if (
            !this.isPatientCreationModelEnabled ||
            !Array.isArray(this.patientCreationModelMap) ||
            this.patientCreationModelMap.length === 0
        ) {
            return null;
        }

        const canonicalLabel = this.getCanonicalGeneralDetailsKey(label);
        return (
            this.patientCreationModelMap.find(
                (f: any) =>
                    this.matchesConfiguredField(f, canonicalLabel) ||
                    this.getCanonicalGeneralDetailsKey(f?.label) === canonicalLabel ||
                    this.getCanonicalGeneralDetailsKey(f?.dataProperty) === canonicalLabel ||
                    this.getCanonicalGeneralDetailsKey(f?.displayName) === canonicalLabel,
            ) || null
        );
    }

    isEditable(label: string, mode?: 'edit' | 'create'): boolean {
        const canonicalLabel = this.getCanonicalGeneralDetailsKey(label);

        if (this.data?.editPatient || mode === 'edit') {
            if (this.editGeneralDetailsConfigPresent) {
                return this.editGeneralDetailsEditableFields.has(canonicalLabel);
            }
            return true;
        }

        if (
            this.isPatientCreationModelEnabled &&
            Array.isArray(this.patientCreationModelMap) &&
            this.patientCreationModelMap.length > 0
        ) {
            const createFieldConfig = this.getCreateFieldConfig(canonicalLabel);
            if (createFieldConfig) {
                return !this.hasExplicitNonEditableFlag(createFieldConfig);
            }
        }

        return true;
    }

    isAdditionalFieldEditable(field: any): boolean {
        return !this.hasExplicitNonEditableFlag(field);
    }

    private hasExplicitNonEditableFlag(config: any): boolean {
        if (!config || typeof config !== 'object') {
            return false;
        }

        const editableKeys = [
            'isEditable'
        ];

        for (const key of editableKeys) {
            if (!Object.prototype.hasOwnProperty.call(config, key)) {
                continue;
            }

            const value = config[key];
            if (value === false || value === 0 || value === 'false' || value === '0') {
                return true;
            }
            return false;
        }

        return false;
    }

    private normalizeGeneralDetailsKey(value: any): string {
        return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    private getCanonicalGeneralDetailsKey(value: any): string {
        const normalizedValue = this.normalizeGeneralDetailsKey(value);
        const keyAliasMap: { [key: string]: string[] } = {
            patientId: ['patientid', 'medicalrecordnumber', 'mrn', 'externalid'],
            firstName: ['firstname'],
            middleName: ['middlename'],
            lastName: ['lastname'],
            dateOfBirth: ['dateofbirth', 'dob'],
            gender: ['gender', 'birthgender'],
            email: ['email', 'primaryemail', 'patientemail'],
            cellPhone: ['cellphone', 'patientphonenumber', 'primarynumber', 'phonenumber'],
            homePhone: ['homephone', 'patienthomephonenumber'],
            address: ['address', 'homeaddress', 'patientaddress'],
            preferredLanguage: ['preferredlanguage', 'language'],
            timezone: ['timezone', 'timezoneid', 'timezonename'],
            healthPlan: ['healthplan', 'planname', 'insurancename'],
            leadSource: ['leadsource'],
            callSource: ['callsource'],
        };

        const canonicalKey = Object.keys(keyAliasMap).find((key) =>
            keyAliasMap[key].includes(normalizedValue),
        );

        return canonicalKey || normalizedValue;
    }

    private getConfiguredGeneralDetailFields(): any[] {
        const generalDetailsConfig =
            this.data?.patientAdditionalFields?.generalDetails;

        this.editGeneralDetailsConfigPresent = this.hasGeneralDetailsConfig(
            this.data?.patientAdditionalFields,
        );

        const generalDetailsFields =
            (Array.isArray(generalDetailsConfig?.fields) && generalDetailsConfig.fields) ||
            (Array.isArray(generalDetailsConfig?.columns) && generalDetailsConfig.columns) ||
            [];

        if (this.editGeneralDetailsConfigPresent) {
            return generalDetailsFields;
        }

        return this.getDefaultGeneralDetailsFields();
    }

    private setEditGeneralDetailsConfig(): void {
        const configuredFields = this.getConfiguredGeneralDetailFields();

        const visibleFields = new Set<string>();
        const requiredFields = new Set<string>();
        const editableFields = new Set<string>();

        if (!this.editGeneralDetailsConfigPresent) {
            this.getDefaultGeneralDetailsFields().forEach((key) => {
                const canonicalKey = this.getCanonicalGeneralDetailsKey(key);
                visibleFields.add(canonicalKey);
                editableFields.add(canonicalKey);
            });

            this.editGeneralDetailsVisibleFields = visibleFields;
            this.editGeneralDetailsRequiredFields = requiredFields;
            this.editGeneralDetailsEditableFields = editableFields;
            return;
        }

        configuredFields.forEach((field: any) => {
            const rawKey =
                typeof field === 'string'
                    ? field
                    : field?.dataProperty ||
                      field?.label ||
                      field?.columnValue ||
                      field?.columnName ||
                      field?.displayName ||
                      field?.name ||
                      '';

            if (!rawKey) {
                return;
            }

            const canonicalKey = this.getCanonicalGeneralDetailsKey(rawKey);
            visibleFields.add(canonicalKey);

            if (typeof field === 'object' && this.isFieldRequired(field)) {
                requiredFields.add(canonicalKey);
            }

            if (
                typeof field !== 'object' ||
                !this.hasExplicitNonEditableFlag(field)
            ) {
                editableFields.add(canonicalKey);
            }
        });

        this.editGeneralDetailsVisibleFields = visibleFields;
        this.editGeneralDetailsRequiredFields = requiredFields;
        this.editGeneralDetailsEditableFields = editableFields;
    }

    private hasGeneralDetailsConfig(patientAdditionalFields: any): boolean {
        if (!patientAdditionalFields || typeof patientAdditionalFields !== 'object') {
            return false;
        }

        if (!Object.prototype.hasOwnProperty.call(patientAdditionalFields, 'generalDetails')) {
            return false;
        }

        const generalDetails = patientAdditionalFields.generalDetails;
        if (!generalDetails || typeof generalDetails !== 'object') {
            return false;
        }

        return (
            Array.isArray(generalDetails.fields) ||
            Array.isArray(generalDetails.columns)
        );
    }

    private getDefaultGeneralDetailsFields(): string[] {
        return [
            'patientId',
            'firstName',
            'middleName',
            'lastName',
            'gender',
            'dateOfBirth',
            'cellPhone',
            'homePhone',
            'email',
            'address',
            'healthPlan',
            'preferredLanguage',
            'timezone',
            'leadSource',
        ];
    }

    private getEditGeneralDetailsPayload(): Record<string, any> {
        const additionalDetails: Record<string, any> = {};
        const visibleFields = this.editGeneralDetailsVisibleFields;
        const shouldInclude = (field: string) =>
            !visibleFields.size || visibleFields.has(field);
        const patientInfo = this.patientInformationObject.patientInfo;
        const originalInfo = this.initialEditValues?.patientInfo || {};

        if (shouldInclude('healthPlan')) {
            this.assignIfChanged(
                additionalDetails,
                'healthPlan',
                patientInfo.healthPlan?.trim() || '',
                originalInfo.healthPlan?.trim() || '',
            );
        }
        if (shouldInclude('preferredLanguage')) {
            this.assignIfChanged(
                additionalDetails,
                'language',
                patientInfo.language?.trim() || '',
                originalInfo.language?.trim() || '',
            );
        }
        if (shouldInclude('leadSource')) {
            this.assignIfChanged(
                additionalDetails,
                'leadSource',
                patientInfo.leadSource?.trim() || '',
                originalInfo.leadSource?.trim() || '',
            );
        }
        if (shouldInclude('callSource')) {
            this.assignIfChanged(
                additionalDetails,
                'callSource',
                patientInfo.callSource?.trim() || '',
                originalInfo.callSource?.trim() || '',
            );
        }
        if (shouldInclude('gender')) {
            this.assignIfChanged(
                additionalDetails,
                'gender',
                patientInfo.gender?.trim() || '',
                originalInfo.gender?.trim() || '',
            );
        }
        if (shouldInclude('timezone')) {
            this.assignIfChanged(
                additionalDetails,
                'timeZone',
                patientInfo.address?.timezone?.trim() || '',
                originalInfo.address?.timezone?.trim() || '',
            );
        }

        return additionalDetails;
    }

    private getChangedAddressPayload(): Record<string, any> {
        const address = this.patientInformationObject.patientInfo.address || {};
        const originalAddress =
            this.initialEditValues?.patientInfo?.address || {};
        if (!this.data?.editPatient || !this.initialEditValues) {
            return { ...address };
        }
        const changed: Record<string, any> = {};
        Object.keys(address).forEach((key) => {
            if (key === 'timezone') {
                return;
            }
            const currentVal = typeof address[key] === 'string' ? address[key].trim() : address[key];
            const origVal = typeof originalAddress[key] === 'string' ? originalAddress[key].trim() : originalAddress[key];
            this.assignIfChanged(
                changed,
                key,
                currentVal,
                origVal,
            );
        });
        return changed;
    }

    private getOriginalAdditionalFieldValue(col: any): any {
        const original = this.initialEditValues?.additional || {};
        const value = original[col?.dataProperty];
        if (value === undefined || value === null) {
            return '';
        }
        if (col?.type == 'NUMERIC(PHONE)') {
            return this.formatPhoneNumber(value);
        }
        if (col?.type == 'BOOLEAN') {
            return !!value;
        }
        return typeof value === 'string' ? value.trim() : (value || '');
    }
    cleanObject<T extends object>(obj: T): Partial<T> {
        const cleaned: Partial<T> = {};

        Object.keys(obj).forEach((key) => {
            const value = obj[key as keyof T] as unknown;

            if (value && typeof value === 'object') {
                if (Array.isArray(value)) {
                    const filteredArray = value
                        .map((item) =>
                            typeof item === 'object' && item !== null
                                ? this.cleanObject(item as object)
                                : item,
                        )
                        .filter((item) => {
                            if (item === null || item === undefined)
                                return false;
                            if (typeof item === 'string' && item.trim() === '')
                                return false;
                            if (
                                typeof item === 'object' &&
                                Object.keys(item).length === 0
                            )
                                return false;
                            return true;
                        });

                    if (filteredArray.length > 0) {
                        cleaned[key as keyof T] = filteredArray as any;
                    }
                } else {
                    const nested = this.cleanObject(value as object);
                    if (Object.keys(nested).length > 0) {
                        cleaned[key as keyof T] = nested as any;
                    }
                }
            } else if (
                value !== null &&
                value !== undefined &&
                !(typeof value === 'string' && value.trim() === '')
            ) {
                cleaned[key as keyof T] = value as any;
            }
        });

        return cleaned;
    }
    getDropDownList(columnValue: string): string[] {
        if (columnValue === 'leadSource') {
            return this.leadSourceArray;
        } else if (columnValue === 'callSource') {
            return this.callSourceArray;
        } else if (columnValue === 'gender') {
            return this.genderArray;
        } else if (columnValue.toString().toLowerCase().includes('relationship')) {
            return this.relationshipArray;
        } else if (columnValue === 'salutation') {
            return this.salutationArray;
        } else if (columnValue === 'healthPlan') {
            return this.healthPlanArray;
        } else if (columnValue === 'language' || columnValue === 'preferredLanguage') {
            return this.languageArray;
        } else if (columnValue === 'timeZone' || columnValue === 'timezone') {
            return this.timezoneArray;
        } else if (columnValue === 'enrollmentStatus') {
            return this.enrollmentStatusArray;
        } else if (columnValue === 'leadStatus') {
            return this.leadStatusArray;
        } else if (columnValue === 'preferredApptReminderMethod') {
            return this.preferredApptReminderMethodArray;
        } else if (columnValue === 'carrierType') {
            return this.carrierTypeArray;
        } else if (columnValue === 'medicarePrescriptionPaymentPlan') {
            return this.medicarePrescriptionPaymentPlanArray;
        } else if (columnValue === 'digitalConsent') {
            return this.digitalConsentArray;
        }

        return [];
    }

    private ensureCategoryIdsForConfiguredDropdowns(): void {
        if (
            (this.hasField('timeZone') || this.hasField('timezone')) &&
            !this.categoryIds.includes(
                reservedCodeCategories.reservedCodeCategoryUnitedStatesTimezoneId,
            )
        ) {
            this.categoryIds.push(
                reservedCodeCategories.reservedCodeCategoryUnitedStatesTimezoneId,
            );
        }

        if (
            this.hasField('enrollmentStatus') &&
            !this.categoryIds.includes(
                reservedCodeCategories.reservedCodeCategoryPatientEnrollmentStatusId,
            )
        ) {
            this.categoryIds.push(
                reservedCodeCategories.reservedCodeCategoryPatientEnrollmentStatusId,
            );
        }
    }

    getCodeValuesByCategory() {
        this.createNewPatientService
            .getCodeValuesByCategory(this.categoryIds)
            .subscribe({
                next: (result: any) => {
                    result.data.forEach((col: any) => {
                        if (col.id == reservedCodeCategories.reservedCodeCategoryPatientLeadSourceId) {
                            this.leadSourceArray = col.codeCategoryValues.map(
                                (item: any) => item.valueShortDescription,
                            );
                        } else if (
                            col.id == reservedCodeCategories.reservedCodeCategoryUnitedStatesTimezoneId
                        ) {
                            this.timezoneArray = col.codeCategoryValues.map(
                                (item: any) => item.valueShortDescription,
                            );
                        } else if (
                            col.id == reservedCodeCategories.reservedCodeCategoryPreferredlanguageId
                        ) {
                            this.languageArray = col.codeCategoryValues.map(
                                (item: any) => item.valueShortDescription,
                            );
                        } else if (
                            col.id == reservedCodeCategories.reservedCodeCategoryPatientHealthPlanId
                        ) {
                            this.healthPlanArray = col.codeCategoryValues.map(
                                (item: any) => item.valueShortDescription,
                            );
                        } else if (
                            col.id == reservedCodeCategories.reservedCodeCategoryPatientCallSourceId
                        ) {
                            this.callSourceArray = col.codeCategoryValues.map(
                                (item: any) => item.valueShortDescription,
                            );
                        } else if (
                            col.id == reservedCodeCategories.reservedCodeCategoryPatientEnrollmentStatusId
                        ) {
                            this.enrollmentStatusArray =
                                col.codeCategoryValues.map(
                                    (item: any) => item.valueShortDescription,
                                );
                        }

                    });
                },
                error: (error: HttpErrorResponse) => {
                    console.log('An Error Occurred', error);
                },
            });
    }
}